<div class="zwi-main__side zwi-md-block">
  <zwi-nav-menu [menuItems]="menuItems"></zwi-nav-menu>
</div>
<div class="zwi-main__content">
  <div class="zwi-content__wrapper">
    <router-outlet></router-outlet>
  </div>
</div>
